import { ReactNode, useEffect, useRef, useState } from "react";

interface Props {
  children: ReactNode;
  id?: string;
}

export default function LazySection({ children, id }: Props) {
  const ref = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    observer.observe(element);

    return () => {
      if (element) observer.unobserve(element);
    };
  }, []);

  return (
    <div
      ref={ref}
      id={id}
      style={{
        minHeight: "200px",
      }}
    >
      {children}
    </div>
  );
}
